import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Inject, Input } from '@angular/core';

import { CorePlatformService } from '@core/infrastructure/platform/platform.service';

@Directive({
    selector: '[offsetBodyObserver]',
    standalone: true,
})
export class OffsetBodyDirective implements AfterViewInit {
    @Input() public propertyCss = '--offset-body';

    constructor(
        private readonly elementRef: ElementRef,
        @Inject(DOCUMENT) private readonly document: Document,
        private readonly platformService: CorePlatformService,
    ) {}

    public async ngAfterViewInit(): Promise<void> {
        if (this.platformService.isBrowser()) {
            const element = await this.elementRef.nativeElement;

            this.document.body.style.setProperty(
                this.propertyCss,
                element.clientHeight > 0 ? `${element.clientHeight}px` : '0px'
            );

            const observer = new MutationObserver(() => {
                this.document.body.style.setProperty(
                    this.propertyCss,
                    element.clientHeight > 0 ? `${element.clientHeight}px` : '0px'
                );
            });

            observer.observe(element, {
                attributes: true,
                childList: true,
                subtree: true,
            });
        }
    }
}
